import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ItemFactory from './ItemFactory.jsx'
import style from './style.css';

export default class RootItem extends React.Component {
  
  static propTypes = {
    parent : PropTypes.object,
    item : PropTypes.object,
    blueprint : PropTypes.object,
    onSelect : PropTypes.func,
    selectedItem : PropTypes.object
  }

  state = {
    open : false,
  };

  constructor( props ) {
    super( props );
    this.onSelect = this.onSelect.bind( this );
  }

  create( item ) {
    return ItemFactory.createTreeItem( item, { 
      key : item.id,
      parent : this.props.item, 
      item, 
      blueprint : this.props.blueprint,
      onSelect : this.props.onSelect,
      selectedItem : this.props.selectedItem
    } )
  
  }

  onSelect() {
    if ( this.props.onSelect ) {
      this.props.onSelect( this.props.item );
    }
  }

  render() {

    const { parent, item, blueprint } = this.props
    
    const children = [];
    if ( item.items ) { 
      for ( let n = 0; n < item.items.length; n++ ) {
        const c = this.create( item.items[n] );
        if ( c ) {
          children.push( c );
        }
      }
    }

    const desc = item.desc == null ? null :                   
    <div className={style.attributeSubtitle}>{item.desc}</div>
    const selected = this.props.item == this.props.selectedItem;
    const cn = classNames( style.rootItem, style.attributeArea, selected ? style.selected : null );
    return (
      <div className={style.attributeGroup}>
        <div className={cn} onClick={this.onSelect}>
          <div className={style.attributeNames}>
            <div className={classNames( style.rootItemTitle, style.attributeTitle )}>
              { ( blueprint && blueprint.name ) || 'Data Attributes'}
            </div>
            {desc}
          </div>
        </div>
        <div className={classNames( style.rootChildren, style.attributeChildren )}>{children}</div>
      </div>
    )
  }

}
